import { Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { Observable } from "rxjs";

// Models
import { AccountType } from '../../../../accounts-v2/models/fields/accountType.model';
import { AnnualRevenue } from '../../model/annualRevenue.model';
import { Currency } from '../../model/currency.model';
import { EmployeeCount } from "../../model/employeeCount.model";
import { Industry } from "../../model/industry.model";
import { Ownership } from "../../model/ownership.model";
import { Rating } from "../../model/rating.model";
import { Timezone } from "../../model/timezone.model";

// Actions
import { beginGetAccountTypes, beginGetAnnualRevenues, beginGetCurrencies, beginGetEmployeeCounts, beginGetIndustries,
    beginGetOwnerships, beginGetRatings, beginGetTimezones } from "./accountLeadData.actions";

@Injectable({ providedIn: 'root' })
export class AccountLeadDataService {
    constructor(
        private store: Store<{
            accountTypes: AccountType[],
            annualRevenues: AnnualRevenue[],
            currencies: Currency[],
            employeeCounts: EmployeeCount[],
            industries: Industry[],
            ownerships: Ownership[],
            ratings: Rating[],
            timezones: Timezone[]
        }>) {
    }

    dispatchGettingAllStores(): void {
        this.store.dispatch(beginGetAccountTypes());
        this.store.dispatch(beginGetAnnualRevenues());
        // this.store.dispatch(beginGetCurrencies());
        this.store.dispatch(beginGetEmployeeCounts());
        this.store.dispatch(beginGetIndustries());
        this.store.dispatch(beginGetOwnerships());
        this.store.dispatch(beginGetRatings());
        this.store.dispatch(beginGetTimezones());
    }

    loadAccountTypes(): Observable<AccountType[]> {
        return this.store.pipe(select('accountTypes'));
    }

    loadAnnualRevenues(): Observable<AnnualRevenue[]> {
        return this.store.pipe(select('annualRevenues'));
    }

    loadCurrencies(): Observable<Currency[]> {
        return this.store.pipe(select('currencies'));
    }

    loadEmployeeCounts(): Observable<EmployeeCount[]> {
        return this.store.pipe(select('employeeCounts'));
    }

    loadIndustries(): Observable<Industry[]> {
        return this.store.pipe(select('industries'));
    }

    loadOwnerships(): Observable<Ownership[]> {
        return this.store.pipe(select('ownerships'));
    }

    loadRatings(): Observable<Rating[]> {
        return this.store.pipe(select('ratings'));
    }

    loadTimezones(): Observable<Timezone[]> {
        return this.store.pipe(select('timezones'));
    }
}
